import { useTranslation } from "react-i18next";
import TypewriterChapterMark from "../../Utils/TypewriterChapterMark";
import ContactForm from "./ContactForm";
import ContactHeader from "./ContactHeader";

const ContactSection = ({ onFocusChange, onMessageFocus, onButtonHover }) => {
  const { t } = useTranslation();
  const handleFormSubmit = (data) => {
    // 1. Construct the Calendly URL
    // NOTE: You should replace this with your actual Calendly URL
    const baseUrl = "https://calendly.com/albert-kaminskii/30min";

    // 2. Add parameters for pre-filling
    const params = new URLSearchParams();
    if (data.name) params.append("name", data.name);
    if (data.email) params.append("email", data.email);
    if (data.message) params.append("a1", data.message); // 'a1' is often custom answer 1, check your Calendly settings

    // 3. Redirect the user
    // We use window.open to open in a new tab so they don't lose the portfolio context completely,
    // or window.location.href to fully redirect. User said "redirected", likely implies full nav.
    // Let's stick to full redirect as requested.
    window.open(`${baseUrl}?${params.toString()}`, "_blank");
  };

  return (
    <section
      id="contact"
      style={{
        borderBottom: "none",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TypewriterChapterMark text="05 / CONTACT" />

      <ContactHeader />

      <div
        className="contact-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
          gap: "40px",
          width: "100%",
          flexGrow: 1,
          borderTop: "1px solid var(--border-color)", // Matching section border style
          paddingTop: "40px",
        }}
      >
        {/* Left Column: Form */}
        <div
          className="contact-column"
          style={{ borderRight: "1px solid #ddd", paddingRight: "40px" }}
        >
          <ContactForm
            onFillEnd={handleFormSubmit}
            onFocusChange={onFocusChange}
            onMessageFocus={onMessageFocus}
            onButtonHover={onButtonHover}
          />
        </div>

        {/* Right Column: Socials/Info (Restored) */}
        <div
          className="contact-column stack-grid"
          style={{
            display: "flex",
            flexDirection: "column",
            borderTop: "none",
            marginTop: 0,
            paddingTop: 0,
          }}
        >
          <div className="stack-column" style={{ marginBottom: "40px" }}>
            <h3>{t("contact.social")}</h3>
            <ul className="stack-list">
              <li>
                <a
                  href="https://www.linkedin.com/in/albert-kaminski-02b431254/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "inherit",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  LinkedIn{" "}
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 9L9 3M9 3H4M9 3V8" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/Alfonsomckenzy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "inherit",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  GitHub{" "}
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 9L9 3M9 3H4M9 3V8" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.upwork.com/freelancers/seniorfullstackwebdev"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "inherit",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  Upwork{" "}
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 9L9 3M9 3H4M9 3V8" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="stack-column">
            <h3>{t("contact.email")}</h3>
            <ul className="stack-list">
              <li>
                <a
                  href="mailto:business@codeboxstudios.com"
                  style={{ color: "inherit" }}
                >
                  business@codeboxstudios.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
